import { createContext } from 'react';

import { DirectoryRecordData } from 'api/types/data/directory/directory';

export interface DirectoryContextProps {
  record?: DirectoryRecordData;
  onEnableEdit: (onCallback: () => void) => void;
  onDisableEdit: (onCallback: () => void) => void;
}

export const DirectoryContext = createContext<DirectoryContextProps | null>(
  null
);
